<template>

  <v-layout row class="ma-1">

    <v-layout column class="mr-1" >
      <div v-for="item in this.availableThumbnails"  :key="item.index" class="" >
        <!-- img v-if="item.thumbDownloadURL != null" :src=item.thumbDownloadURL @click=selectImage(item.index) :class="getClass(item.index)"/ -->
        <v-img v-if="item.thumbDownloadURL != null" :src=item.thumbDownloadURL @click=selectImage(item.index) :class="getClass(item.index)"/>
      </div>
    </v-layout>

    <div style="width:80%;">
      <v-img v-if="selectedimg != null" :src=selectedimg  :lazy-src="selectedImgThumbnail" class="imgClass" />
    </div>
  </v-layout>
</template>

<script>

export default {
  name: 'ImagePanel',
  components: {
  },
  props: ['item'],
  computed: {
    availableThumbnails: function () {
      const available = []
      for (let i = 0; i < this.item.thumbnails.length; i++) {
        if (this.item.thumbnails[i]) {
          const t = this.item.thumbnails[i]
          t.index = i
          // t.class = this.notSelectedClass
          available.push(t)
        }
      }
      console.log('AVAIL:' + available)
      return available
    }
  },
  data () {
    return {
      selectedimg: null,
      selectedImgThumbnail: null,
      selectedIndex: 0,
      selectedClass: ' selected mb-1',
      notSelectedClass: ' mb-1'
    }
  },
  mounted: function () {
    this.selectImage(0)
  },
  methods: {
    getClass (index) {
      if (index === this.selectedIndex) {
        return this.selectedClass
      } else {
        return this.notSelectedClass
      }
    },
    selectImage (index) {
      if (this.availableThumbnails[index]) {
        this.selectedImgThumbnail = this.availableThumbnails[index].thumbDownloadURL
        this.selectedimg = this.availableThumbnails[index].downloadURL
        this.selectedIndex = index
        // for (let i = 0; i < this.availableThumbnails.length; i++) {
        //   this.availableThumbnails[i].class = this.notSelectedClass
        // }
        // this.availableThumbnails[index].class = this.selectedClass
      } else {
        this.selectedimg = '/images/noimage.png'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.topContainer {
  height:60vh;
}
.imgPanelContainer {
}
.imgClass {
  /* max-height: 60vh;
  /* max-width:90%;
  max-height:100%; */
}
.imagepanel {
  margin:10px;
  margin: auto;
}
.thumbbar {
  margin:2px;
}

.selected {
  border: 2px solid green;
}

</style>
